<template>
  <v-container fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn class="ma-3" icon :loading="loading" @click="load">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-col
          v-for="device in devices"
          :key="device.id"
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="3"
      >
        <DeviceCard :device="device" @updated="onUpdated"></DeviceCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DeviceCard from './model/DeviceCard'
import { smarthausApi } from '../../services/smarthaus'

export default {
  name: 'DeviceView',
  components: { DeviceCard },
  data: () => ({
    devices: [],
    loading: false,
  }),
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const data = await smarthausApi.devices()
        this.devices = data.devices
      } catch (e) {
        console.error('[DeviceView]', e)
      } finally {
        this.loading = false
      }
    },
    onUpdated(device) {
      const index = this.devices.findIndex((d) => d.id === device.id)
      if (index !== -1) this.devices.splice(index, 1, device)
    },
  },
}
</script>

<style scoped>

</style>
